import type { Platform, ShareContent } from '../types';
import { PlatformRegistry } from './registry';

/** Check if the user is on Android */
function isAndroid(): boolean {
  if (typeof navigator === 'undefined') return false;
  return /Android/i.test(navigator.userAgent);
}

/** Check if the user is on iOS */
function isIOS(): boolean {
  if (typeof navigator === 'undefined') return false;
  return /iPhone|iPad|iPod/i.test(navigator.userAgent);
}

/** Check if the user is on any mobile device */
function isMobile(): boolean {
  if (typeof navigator === 'undefined') return false;
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}

export const viber: Platform = {
  id: 'viber',
  name: 'Viber',
  iconIndex: PlatformRegistry.viber.index,
  color: PlatformRegistry.viber.color,
  buildUrl: (content: ShareContent): string => {
    const text = encodeURIComponent([content.title, content.url].filter(Boolean).join(' '));

    if (isAndroid()) {
      // Android intent with app fallback
      return `intent://forward?text=${text}#Intent;scheme=viber;package=com.viber.voip;end`;
    }

    if (isIOS() || isMobile()) {
      // iOS and other mobile devices use deep link
      return `viber://forward?text=${text}`;
    }

    // Desktop fallback
    return 'https://www.viber.com/';
  },
};

